import { IStatusTransition } from "../../models"
import { ODataGetResourceResponse } from "../models/api/data"
import { ConceptDTO, StatusTransitionDTO } from "../models/dto/concept"

import { IConcept } from "../../components/itemdetail"

import { parseStatusDto } from "./itemParsing"

export const parseConceptDto = (
    dto: ConceptDTO | ODataGetResourceResponse<ConceptDTO>,
): IConcept => ({
    label: dto.Label,
    code: dto.Code,
    defaultInitialStatus: parseStatusDto(dto.DefaultInitialStatus),
    defaultFinalStatus: parseStatusDto(dto.DefaultFinalStatus),
    itemType: dto.ItemType,
    id: dto.Id,
    statuses: dto.Statuses.map(parseStatusDto),
})

export const parseStatusTransitionDto = (
    dto: StatusTransitionDTO | ODataGetResourceResponse<StatusTransitionDTO>,
): IStatusTransition => ({
    label: dto.Label,
    conceptId: dto.ConceptId,
    fromStatus: parseStatusDto(dto.FromStatus),
    toStatus: parseStatusDto(dto.ToStatus),
    isActive: dto.IsActive,
    type: dto.Type,
    sequenceNr: dto.SequenceNr,
    id: dto.Id,
})
